import Entities from "./shared/Entities";

export default class ScrollToPosts {
  constructor() {
    this.entities = new Entities("ScrollToPosts", "[data-scroll-posts]", ScrollToPosts.initSingle, ScrollToPosts.destroySingle);
  }

  static initSingle(containerEl) {
    const headers = containerEl.querySelectorAll("[data-section-header]");
    const sections = containerEl.querySelectorAll("[data-section]");

    if (!headers.length || !sections.length) return;

    const state = {
      headers,
      sections,
      onScroll: null,
      onClickHandlers: [],
    };

    headers.forEach((header, index) => {
      const section = sections[index % sections.length];

      if (!section) return;

      let titleEl = section.querySelector("h2") || section.querySelector("h3") || section.querySelector("h4");

      const MAX_LENGTH = 40;

      let titleText = titleEl ? titleEl.textContent.trim() : ``;

      if (titleText.length > MAX_LENGTH) {
        const trimmed = titleText.slice(0, MAX_LENGTH);
        titleText = trimmed.slice(0, trimmed.lastIndexOf(" ")) + "…";
      }

      header.innerHTML = `
    ${titleText}&nbsp;
    <span class="opacity-0 group-data-[active]:opacity-100 duration-300 transition-all"></span>
  `;
    });

    headers.forEach((header, index) => {
      const clickHandler = (e) => {
        e.preventDefault();

        if (index > 3) {
          const expandButton = containerEl.querySelector("[data-sections-button]");

          if (expandButton && !expandButton.hasAttribute("data-active")) {
            expandButton.click();
          }
        }

        const href = header.getAttribute("href");
        const target = containerEl.querySelector(href);

        if (!target) return;

        setTimeout(() => {
          const rect = target.getBoundingClientRect();
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          const targetOffset = rect.top + scrollTop - window.innerHeight / 2 + rect.height / 2;

          window.scrollTo({
            top: targetOffset,
            behavior: "smooth",
          });
        }, 300);
      };

      header.addEventListener("click", clickHandler);
      state.onClickHandlers.push({ header, clickHandler });
    });

    state.onScroll = () => {
      const viewportCenter = window.innerHeight / 2;

      let closestIndex = 0;
      let closestDistance = Infinity;

      sections.forEach((section, index) => {
        const rect = section.getBoundingClientRect();
        const sectionCenter = rect.top + rect.height / 2;
        const distance = Math.abs(viewportCenter - sectionCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      headers.forEach((header, i) => {
        if (i === closestIndex) {
          header.setAttribute("data-active", "");
        } else {
          header.removeAttribute("data-active");
        }
      });
    };

    window.addEventListener("scroll", state.onScroll, { passive: true });

    state.onScroll();

    return state;
  }

  static destroySingle({ entityObj }) {
    if (!entityObj) return;

    const { headers, onClickHandlers, onScroll } = entityObj;

    onClickHandlers.forEach(({ header, clickHandler }) => {
      header.removeEventListener("click", clickHandler);
    });

    if (onScroll) {
      window.removeEventListener("scroll", onScroll);
    }
  }
}
